<div class="row">
    <div class="col-md-12">
        <app-alert-modal *ngIf="alertSuccess"></app-alert-modal>
        <app-alert-save-modal *ngIf="alertSuccessOnSave"></app-alert-save-modal>
        <div class="alert alert-danger" *ngIf="alertFailure">
            Something went wrong while uploading file!
         </div>
         <div class="alert alert-danger" *ngIf="timeOutError">
            {{timeoutErrorMessage}}
         </div>
        <div class="col-md-12 mt-5 event-action-label form-font-family">
            <span class="create-events-title color">{{actionTitle}} EVENT</span>
            <span class="pt-2" style="font-size: 13px;"><a href="assets/userguides/EventCreationUserGuide.pdf" download class="pl-3 download-link">User Guide</a></span>
        </div>
        <form class="form-horizontal form-padding form-font-family" [formGroup]="eventDetailsForm" id="eventDetailsForm">
            <div class="row row-flex">
                <div class="col-md-5 col-sm-6 col-xs-12 form-row form-element-height" *ngIf="(adminId == 1 && actionTitle == 'CREATE')">
                    <label for="eventLevelFlag" class="control-label col-md-4 hoshin-radio-button">Event Level<span class="mandatory-asterisk">*</span></label>
                    <div class="col-md-8 radio-button-padding" (change)="changeEventLevelFlag(eventDetailsForm.get('eventLevelFlag').value)">
                        <input class="radio-input-align" type="radio" name="eventLevelFlag" [value]="true" formControlName="eventLevelFlag" />
                        Chapter
                        <input class="radio-input-align radio-input-margin" type="radio" name="eventLevelFlag" [value]="false"
                            formControlName="eventLevelFlag" /> NAAC
                    </div>
                </div>
                <div class="col-md-5 col-sm-6 col-xs-12 form-row form-element-height" [ngClass]="{'pointerDisable':actionTitle == 'EDIT'}" *ngIf="eventDetailsForm.get('eventLevelFlag').value || editEvent">
                    <label for="chapterId" class="control-label col-md-4">Chapter<span class="mandatory-asterisk">*</span></label>

                   

                    <div class="col-md-8" [ngClass]="{'disableSection':actionTitle == 'EDIT'}">
                       
                        <ng-select formControlName="chapterId" placeholder ="--Select--" [items] = "chapterDropDownList" bindLabel ="siteName" bindValue="chapterId" class="form-control input-lg custom" (change)="onChapterSelection($event)"></ng-select>
                    </div>

                </div>
                <div class="col-md-5 col-sm-6 col-xs-12 form-row form-element-height" [ngClass]="{'pointerDisable':actionTitle == 'EDIT'}" *ngIf="!eventDetailsForm.get('eventLevelFlag').value && !editEvent">
                    <label for="naacId" class="control-label col-md-4">NAAC<span class="mandatory-asterisk">*</span></label>
                    <div class="col-md-8" [ngClass]="{'disableSection':actionTitle == 'EDIT'}">
                        <ng-select formControlName="naacId" placeholder ="--Select--" [items] = "naacList" bindLabel ="naacAffinityName" bindValue="naacId" class="form-control input-lg custom"></ng-select>
                    </div>

                </div>


                <div class="col-md-5 col-sm-6 col-xs-12 form-row form-element-height"  *ngIf="eventDetailsForm.get('eventLevelFlag').value">
                    <label for="eventTypeId" class="control-label col-md-4">Event Type<span class="mandatory-asterisk">*</span></label>
                    <div class="col-md-8">
                       
                        <ng-select formControlName="eventTypeId" placeholder ="--Select--" [items] = "eventTypeDropDownList" bindLabel ="eventType" bindValue="eventTypeId" class="form-control input-lg custom"></ng-select>
                    </div>
                </div>

                <div class="col-md-5 col-sm-6 col-xs-12 form-row form-element-height" *ngIf="eventDetailsForm.get('eventLevelFlag').value" >
                    <label for="isHoshin" class="control-label col-md-4 hoshin-radio-button">Approved Hoshin Initiative<span class="mandatory-asterisk">*</span></label>
                    <div class="col-md-8 radio-button-padding" (change)="disableInputBasedOnSelection(eventDetailsForm.get('isHoshin').value)">
                        <input class="radio-input-align" type="radio" name="isHoshin" [value]="true" formControlName="isHoshin" [ngClass]="{'disableSection': eventDetailsForm.get('eventStatus').value == 'SCHEDULED' && eventDetailsForm.get('eventLevelFlag').value == true}"/>
                        Yes
                        <input class="radio-input-align radio-input-margin" type="radio" name="isHoshin" [value]="false" [ngClass]="{'disableSection': eventDetailsForm.get('eventStatus').value == 'SCHEDULED' && eventDetailsForm.get('eventLevelFlag').value == true}"
                            formControlName="isHoshin" /> No
                    </div>
                </div>


                <div *ngIf="eventDetailsForm.get('isHoshin').value == true && eventDetailsForm.get('eventLevelFlag').value == true" class="col-md-5 col-sm-6 col-xs-12 form-row form-element-height">
                    <label for="hoshinId" class="control-label col-md-4">Hoshin<span class="mandatory-asterisk">*</span></label>
                    <div class="col-md-8">
                     
                        <ng-select formControlName="hoshinId" placeholder ="--Select--" [items] = "HoshinDropDownList" bindLabel ="bpgInitiative" bindValue="hoshinId" class="form-control input-lg custom" [ngClass]="{'disableSection': eventDetailsForm.get('eventStatus').value == 'SCHEDULED' && eventDetailsForm.get('eventLevelFlag').value == true}"></ng-select>
                    </div>
                </div>

                <div *ngIf="eventDetailsForm.get('isHoshin').value == false && eventDetailsForm.get('eventLevelFlag').value == true" class="col-md-5 col-sm-6 col-xs-12 form-row form-element-height">
                    <label for="explainNonHoshin" class="control-label col-md-4">Non Hoshin Reason<span class="mandatory-asterisk">*</span></label>
                    <div class="col-md-8">
                        <input type="text" [maxlength]="500" autocomplete="off" name="explainNonHoshin" placeholder="Enter reason"
                            class="form-control input-lg" formControlName="explainNonHoshin"></div>
                </div>

                <!-- Included radio button to check if meeting is virtual -->
                <div class="col-md-5 col-sm-6 col-xs-12 form-row form-element-height"  *ngIf="eventDetailsForm.get('eventLevelFlag').value">
                    <label for="virtualFlag" class="control-label col-md-4">Virtual Meeting</label>
                    <div class="col-md-8 radio-button-padding">

                        <input type="radio" input class="radio-input-align" name="virtualFlag"
                            formControlName="virtualFlag" [value]="true" /> Yes
                        <input type="radio" input class="radio-input-align radio-input-margin" name="virtualFlag"
                            formControlName="virtualFlag" [value]="false" /> No

                    </div>
                </div>

                <div class="col-md-5 col-sm-6 col-xs-12 form-row form-element-height">
                    <label for="eventName" class="control-label col-md-4">Event Name<span class="mandatory-asterisk">*</span></label>
                    <div class="col-md-8">
                        <input type="text" [maxlength]="250" autocomplete="off" placeholder="Enter event title" name="eventName"
                            class="form-control input-lg" formControlName="eventName"></div>
                </div>



           

                <div class="col-md-5 col-sm-6 col-xs-12 form-row form-element-height" [ngClass]="{'disableSection': ((actionTitle == 'EDIT') )}"  *ngIf="eventDetailsForm.get('eventLevelFlag').value">
                    <div class="col-md-4  radio-button-padding" >
                        Frequency<span class="frequency-star">*</span></div>
                        <div class="col-md-8 radio-button-padding">
                        <input type="radio" input class="radio-input-margin-event-once" id="once" name="occurenceType" value="once" 
                            formControlName="occurenceType"   /> Once
                        <input type="radio" input class="radio-input-margin-event" id="monthly" name="occurenceType" value="monthly" 
                            formControlName="occurenceType"  /> Monthly
                        <input type="radio" input class="radio-input-margin-event"  id="quarterly" name="occurenceType" value="quarterly"
                            formControlName="occurenceType"   /> Quarterly

                        </div>
                
            </div>
            
            <div class="col-md-5 col-sm-6 col-xs-12 form-row form-element-height" [ngClass]="{'disableSection':actionTitle == 'EDIT'}" *ngIf = "((eventDetailsForm.get('eventLevelFlag').value && (eventDetailsForm.get('occurenceType').value == 'weekly') && (actionTitle!='EDIT')))" >
                <div class="col-md-12  radio-button-padding">
                   
                       
                            <label class="sitelabel" for="siteContacts" >Choose days<span
                                class="mandatory-asterisk">*</span></label>  
                   
                                
                          <span *ngFor="let day of weekdayList">
                              <span class="alignleft daycheck ">
                                <label>
                                    
                                  <input type="checkbox"  name="check" [checked]="day.checked" (change)="toggleCheckbox($event,day)" formControlName="chooseday" ><span
                                    class="label-text daycheck" >
                                  <span class="bpg-name bold-text">{{day}}
                                   
                                </span>
                              </span>
                            </label>
                            </span>
                        </span>
                        </div>
                       
                    </div>
                 <!-- Added description field mandatory -->
              

                <div class="col-md-5 col-sm-6 col-xs-12 form-row form-element-height" *ngIf = "(actionTitle!='EDITALL')">
                    <label for="eventCreateDate" class="control-label col-md-4">Event Start Date<span class="mandatory-asterisk">*</span></label>
                    <div class="col-md-8"><input placeholder="Event start date" class="form-control input-lg date-icon" id="date"
                            name="date" type="text" bsDatepicker [minDate]="todaysDate" autocomplete="off" (ngModelChange)="setRegDate(eventDetailsForm.get('eventCreateDate').value)" 
                            formControlName="eventCreateDate" (onShown)="onShowPicker($event)">
                    </div>
                </div>
                <div class="col-md-5 col-sm-6 col-xs-12 form-row form-element-height" *ngIf = "(actionTitle=='EDITALL')">
                    <label for="eventSeries" class="control-label col-md-4 ">Event Start Date<span
                        class="mandatory-asterisk">*</span></label>
                    <div class="col-md-8"><input placeholder="Event start date" class="form-control input-lg date-icon" id="date"
                            name="date" type="text" bsDatepicker autocomplete="off" (ngModelChange)="setEventDate(eventDetailsForm.get('eventSeries').value)" 
                            formControlName="eventSeries" [required]="(actionTitle=='EDITALL')" (onShown)="onShowPicker($event)" [minDate]="todaysDate">
                    </div>
                </div>
                <div class="col-md-5 col-sm-6 col-xs-12 form-row form-element-height" *ngIf = "(eventDetailsForm.get('occurenceType').value != 'once') && actionTitle!='EDIT' &&  eventDetailsForm.get('eventLevelFlag').value">
                    <label for="eventEndDate" class="control-label col-md-4 ">Event End Date<span
                        class="mandatory-asterisk">*</span></label>
                    <div class="col-md-8"><input placeholder="Event end date" class="form-control input-lg date-icon" id="date"
                            name="date" type="text" bsDatepicker autocomplete="off" [minDate]="minEndDate" 
                            formControlName="eventEndDate" (onShown)="onShowPicker($event)" >
                    </div>
                </div>
                
                <div class="col-md-5 col-sm-6 col-xs-12 form-row form-element-height">
                    <label for="startTime" class="control-label col-md-4">Start Time<span class="mandatory-asterisk">*</span></label>
                    <div class="col-md-8"><input placeholder="Choose time" class="form-control input-lg time-icon" 
                        (click)="openStart($event)" arrowStyle="{'background': '#b62027'}" id="startTime" name="startTime" type="text" formControlName="startTime" >
                        <div class="validation-error-message" *ngIf="startTimeGreaterErrorMessage">Start time is
                            greater than end time</div>
                        <div class="validation-error-message" *ngIf="startTimeEqualErrorMessage">Start and end time are
                            equal</div>
                          
                            <div class="validation-error-message" *ngIf="startTimeLessThanCurrentTime">Start time can't be less than or equal to current time</div>

                    </div>
                </div>

                <div class="col-md-5 col-sm-6 col-xs-12 form-row form-element-height">
                    <label for="endTime" class="control-label col-md-4">End Time<span class="mandatory-asterisk">*</span></label>
                    <div class="col-md-8"><input placeholder="Choose time" class="form-control input-lg time-icon"
                        (click)="openEnd($event)" arrowStyle="{'background': '#b62027'}" id="endTime" name="endTime" type="text" formControlName="endTime">
                            <div class="validation-error-message" *ngIf="minDurationErrorMessage">Minimum event duration is one hour</div>
                            <div class="validation-error-message" *ngIf="endTimeLessThanCurrentTime">End time can't be less than current time</div>
                    </div>
                </div>

                



            
                <div class="col-md-5 col-sm-6 col-xs-12 form-row form-element-height">
                    <label for="description" class="control-label col-md-4">Description<span
                      class="mandatory-asterisk">*</span></label>
                   <div class="col-md-8 "><textarea [maxlength]="500" autocomplete="off" placeholder="Enter description"
                      class="form-control form-control-inline text-area-width moz-div-style" id="description" name="description"
                       maxlength="256" formControlName="description"></textarea></div>
                  </div>
           
                <div class="col-md-5 col-sm-6 col-xs-12 form-row form-element-height">
                    <label for="timeZone" class="control-label col-md-4">Timezone<span class="mandatory-asterisk">*</span></label>
                    <div class="col-md-8">
                       

                        <ng-select formControlName="timeZone" placeholder ="--Select--" [items] = "timeZoneList" bindLabel ="name" bindValue="value" class="form-control input-lg custom"></ng-select>

                    </div>
                </div>


                <div class="col-md-5 col-sm-6 col-xs-12 form-row form-element-height">
                    <label for="eventCoordinatorEmail" class="control-label col-md-4">Lead Email</label>
                    <div class="col-md-8"><input type="text" [maxlength]="50" autocomplete="off" placeholder="Enter lead email"
                            name="eventCoordinatorEmail" class="form-control input-lg" formControlName="eventCoordinatorEmail">
                        <div class="validation-error-message" *ngIf="eventDetailsForm.get('eventCoordinatorEmail').invalid && eventDetailsForm.get('eventCoordinatorEmail').touched">Invalid
                            email id</div>
                    </div>
                </div>


                <div class="col-md-5 col-sm-6 col-xs-12 form-row form-element-height">
                    <label for="maxAttendeece" class="control-label col-md-4">Max Attendees<span class="mandatory-asterisk">*</span></label>
                    <div class="col-md-8" ><input type="number" onkeypress="return !((event.charCode == 46||event.charCode == 101||event.charCode == 69)) && (event.charCode >= 48 && event.charCode <= 57)"
                            autocomplete="off" placeholder="Enter max attendees" name="maxAttendeece" class="form-control input-lg"
                            formControlName="maxAttendeece">
                        <div class="validation-error-message" *ngIf="eventDetailsForm.get('maxAttendeece').invalid && eventDetailsForm.get('maxAttendeece').touched">Please
                            enter max attendees in numbers</div>
                            <div class="validation-error-message" *ngIf="maxAttendeesNumberError && eventDetailsForm.get('maxAttendeece').valid ">Value can't be less than previously approved attendees {{this.oldMaxAttendeece}}</div>
                    </div>
                </div>

                <div *ngIf="eventDetailsForm.get('eventCreateDate').value != null && eventDetailsForm.get('eventLevelFlag').value" class="col-md-5 col-sm-6 col-xs-12 form-row form-element-height">
                    <label for="registrationStartDate" class="control-label col-md-4">Registration Start Date<span class="mandatory-asterisk">*</span></label>
                    <div class="col-md-8"><input class="form-control input-lg date-icon" placeholder="Select registration start date" (ngModelChange)="setRegEndMinDate(eventDetailsForm.get('registrationStartDate').value)"
                            id="date" name="date" type="text" bsDatepicker [minDate]="RegMinDate" [maxDate]="previousDate"
                            autocomplete="off" formControlName="registrationStartDate" required (onShown)="onShowPicker($event)">
                        <div class="validation-error-message" *ngIf="startDateGreaterErrorMessage">Reg. start date is
                            greater than reg. end date</div>
                            <div class="validation-error-message" *ngIf="startDateGreaterThanCreateDateErrorMessage">Reg. start date is
                                greater than event date</div>
                    </div>
                </div>

                <div *ngIf="eventDetailsForm.get('eventCreateDate').value != null && eventDetailsForm.get('eventLevelFlag').value" class="col-md-5 col-sm-6 col-xs-12 form-row form-element-height">
                    <label for="registrationEndDate" class="control-label col-md-4">Registration End Date <span class="mandatory-asterisk">*</span></label>
                    <div class="col-md-8"><input class="form-control input-lg date-icon" placeholder="Select registration end date"
                            id="date" name="date" type="text" bsDatepicker autocomplete="off" [minDate]="regEndMinDate"
                            [maxDate]="previousDate" formControlName="registrationEndDate" required (onShown)="onShowPicker($event)">
                            <div class="validation-error-message" *ngIf="endDateGreaterThanCreateDateErrorMessage">Reg. end date is
                                greater than event date</div>
                    </div>
                </div>

               

                <!-- Included  text field for meeting link-->
                <div class="col-md-5 col-sm-6 col-xs-12 form-row form-element-height">
                    <label for="virtualMeetingLinks" class="control-label col-md-4">Meeting Details</label>
                    <div class="col-md-8 "><textarea autocomplete="off" placeholder="Enter Meeting Details"
                            class="form-control form-control-inline text-area-width-meeting moz-div-style" id="virtualMeetingLinks" name="virtualMeetingLinks" 
                             formControlName="virtualMeetingLinks"></textarea></div>
                </div>
                <div class="col-md-5 col-sm-6 col-xs-12 form-row form-element-height"  *ngIf="eventDetailsForm.get('eventLevelFlag').value">
                    <label for="venue" class="control-label col-md-4">Venue<span class="mandatory-asterisk"
                            *ngIf="!eventDetailsForm.get('virtualFlag').value">*</span></label>
                    <div class="col-md-8">
                        <input type="text" [maxlength]="500" autocomplete="off" name="venue"
                            [required]="!eventDetailsForm.get('virtualFlag').value" placeholder="Enter location"
                            class="form-control input-lg" formControlName="venue">
                    </div>
                </div>
                <div class="col-md-5 col-sm-6 col-xs-12 form-row form-element-height">
                    <label for="eventDocumentUrl" class="control-label col-md-4">Event Document</label>
                    <div class="col-md-8"><input type="file" id="eventDocumentUrl" (change)="onFileSelected($event)"
                            name="eventDocumentUrl" placeholder="Upload" class="form-control input-lg upload-icon hideInput">
                            <a class="deleteButton delete-button-style" title="delete" (click)="removeFile()"><img src="assets/images/delete.png" class="image" alt="Angular Logo"></a>
                            <label class="form-control input-lg upload-icon file-name-padding" for="eventDocumentUrl"><label
                                class="docNameEllipsis">{{fileName}}</label>
                            </label>

                        <div class="validation-error-message" *ngIf="fileExtensionError">You can only upload the file
                            of type jpg, jpeg, png, pdf, ppt, pptx, txt, doc, docx, xlsx, csv</div>
                        <div class="validation-error-message" *ngIf="fileSizeExtensionError">You can only upload the
                            file of size less than 5MB </div>
                        </div>
                </div>

                <div class="col-md-5 col-sm-6 col-xs-12 form-row form-element-height"  *ngIf="eventDetailsForm.get('eventLevelFlag').value">
                    <label for="sendEmail" class="col-md-4 email-field-check">Notify Chapter Members</label>
                    <div class="col-md-8 emailcheck"> 
                          <label>
                              <input type="checkbox"  name="sendEmail" [checked]="eventDetailsForm.get('sendEmail').value"  formControlName="sendEmail" >
                              <span class="label-text daycheck" ></span>
                          </label>  
                    </div>
                </div>
                <div *ngIf="this.editEventData != null && this.editEventData.eventStatus != null" class="col-md-5 col-sm-6 col-xs-12 form-row form-element-height">
                  
                    <label for="rejectedComments" *ngIf="this.editEventData != null && this.editEventData.eventStatus == 'REJECTED'" class="control-label col-md-4">Rejected Comment</label>
                    <div id="rejectedComments" class="col-md-8 status-style" *ngIf="this.editEventData != null && this.editEventData.eventStatus == 'REJECTED'"><span class=" col-md-7 comment-content">{{this.editEventData.approvalComment}}</span>

                    </div>
                </div>

                <div *ngIf="this.editEventData != null && this.editEventData.eventStatus != null" class="col-md-5 col-sm-6 col-xs-12 form-row form-element-height">
              
                    <label for="rejectedBy" *ngIf="this.editEventData != null && this.editEventData.eventStatus == 'REJECTED'" class="control-label-approved-rejected col-md-4">Rejected By</label>
                    <div id="rejectedBy" class="col-md-8 status-style-approved-rejected" *ngIf="this.editEventData != null && this.editEventData.eventStatus == 'REJECTED'"><span class=" col-md-7 comment-content">{{this.editEventData.approverName}}</span>

                    </div>
                </div>

            </div>

            <div class="form-group event-btnalign-for-ipad">
                <button type="button" (click)="saveClick()" [disabled]="eventDetailsForm.invalid" data-toggle="modal"
                    data-target="#myModal" class="btn btn-danger col-sm-2 col-md-2 font-family-button button-margin" id="saveButton">SAVE</button>
                <button type="button" (click)="submitClick()" [disabled]="eventDetailsForm.invalid" data-toggle="modal"
                    data-target="#myModal" class="btn btn-danger col-sm-2 col-md-2 font-family-button button-margin" id="saveSubmitButton">SAVE
                    & SUBMIT</button>
                <button type="button" class="btn btn-danger col-sm-2 col-md-2 font-family-button button-margin"
                    data-toggle="modal" data-target="#myModal" (click)="cancelClick()">CANCEL</button>
                <app-confirmation-modal [PData]="msg1" (emitPass)="this[method](param)" id="1"></app-confirmation-modal>
            </div>
        </form>
    </div>
</div>
